export default "__VITE_ASSET__oMn24b3u__"